<template>
  <BaseLayout page-default-back-link="/nativeTab/news" pageTitle="我的附件" :showFooter="true">
    <div class="uploadFile-select p-20">
      <div class="file-item" @click="toUploadFile">
        <div class="image-box">
          <img class="selectFileAddImage" src="@/assets/selectFile-add.png" />
        </div>
        <div class="f-center font-sm m-t-20 m-b-10">新增附件</div>
      </div>
      <div class="file-item" v-for="(file, index) in files" :key="index" @click="submit(file)">
        <img class="image" :src="file.imageUrl" />
        <div class="f-center font-sm m-t-20 m-b-10">{{file.title}}</div>
        <div class="f-center font-ms gray-font">{{file.time}}</div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import { fileApi } from '@/apis'
import router from '@/router'
import { useRoute } from 'vue-router'
import { toast } from '@/utils/alert'

export default {
  setup(props, { emit }) {
    const route = new useRoute()
    const files = ref([])

    const toUploadFile = () => {
      router.push({
        path: '/uploadFile',
        query: {
          processNodeTblId: route.query.processNodeTblId,
          tblId: route.query.tblId,
        },
      })
    }

    const getData = async () => {
      const { list = [] } = await fileApi.appendixList()
      files.value = list.map((item) => ({
        id: item.id,
        imageUrl: item.validUri,
        title: item.upName,
        time: item.createTimeStr.split(' ')[0],
      }))
      console.log('DD', files.value)
    }

    const submit = async (file) => {
      await fileApi.appendixUpload({
        processNodeTblId: route.query.processNodeTblId,
        tblId: route.query.tblId,
        fileIdArray: [file.id],
      })
      toast('提交')
      router.replace({
        path: '/nativeTab/news',
      })
    }

    onMounted(() => {
      getData()
    })

    return { files, toUploadFile, submit }
  },
  components: {},
}
</script>
<style lang="scss">
.uploadFile-select {
  display: flex;
  flex-wrap: wrap;

  .file-item {
    display: flex;
    flex-direction: column;
    width: 224px;
    height: 338px;
    border: 1px solid #dfe5f0;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px;
    margin-bottom: 20px;
    .image-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 176px;
      height: 176px;
      background: #fafbff;
      border: 1px solid #dfe5f0;
      border-radius: 8px;
      border-radius: 4px;
    }
    .selectFileAddImage {
      width: 50px;
      height: 50px;
      border-radius: 4px;
    }
    .image {
      width: 176px;
      height: 176px;
    }
  }
  .file-item:nth-child(3n + 2) {
    margin-left: 16px;
    margin-right: 16px;
  }
}
</style>